mutation assignLeads($input: AssignLeadsInput!) {
  assignLeads(input: $input)
}
